import type { FC } from 'react';
import React from 'react';

import styles from './ActionPanel.module.scss';

export interface ActionPanelProject {
    id: string;
    name: string;
    done: number;
    total: number;
    price: number;
}

interface ActionPanelProps {
    lastProject?: ActionPanelProject | null;
    isLoading?: boolean;
    onCreate: () => void;
    onOpenProjects: () => void;
    onOpenProject: (projectId: string) => void;
}

const money = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
});

export const ActionPanel: FC<ActionPanelProps> = ({
    lastProject = null,
    isLoading = false,
    onCreate,
    onOpenProjects,
    onOpenProject,
}) => {
    const percent = lastProject?.total
        ? Math.round((lastProject.done / lastProject.total) * 100)
        : 0;

    return (
        <section className={styles.action}>
            <div className={styles.copy}>
                <div className={styles.txt}>
                    <h2>Новый анализ рыночных цен</h2>

                    <p>Создайте проект, добавьте товарные позиции и запустите поиск предложений.</p>
                </div>

                <div className={styles.buttons}>
                    <button
                        type="button"
                        className={`${styles.btn} ${styles.btnPrimary}`}
                        onClick={onCreate}
                    >
                        Создать проект
                    </button>

                    <button
                        type="button"
                        className={`${styles.btn} ${styles.btnGlass}`}
                        onClick={onOpenProjects}
                    >
                        Все проекты
                    </button>
                </div>
            </div>

            <div className={styles.context}>
                {lastProject ? (
                    <button
                        type="button"
                        className={styles.contextLink}
                        aria-label={`Открыть проект «${lastProject.name}»`}
                        onClick={() => onOpenProject(lastProject.id)}
                    >
                        <span className={styles.contextTitle}>Продолжить работу</span>
                        <span className={styles.lastProject}>{lastProject.name}</span>

                        <div className={styles.progress}>
                            <i style={{ width: `${percent}%` }} />
                        </div>

                        <div className={styles.meta}>
                            <div>
                                <span>Позиции</span>
                                <b>
                                    {lastProject.done} из {lastProject.total}
                                </b>
                            </div>

                            <div>
                                <span>Текущая цена</span>
                                <b>{money.format(lastProject.price)}</b>
                            </div>
                        </div>
                    </button>
                ) : isLoading ? (
                    <div className={styles.skeleton} aria-hidden="true">
                        <span className={styles.contextTitle}>Продолжить работу</span>
                        <span className={styles.skeletonLine} />
                        <div className={styles.progress}>
                            <i style={{ width: '0%' }} />
                        </div>
                        <div className={styles.meta}>
                            <div>
                                <span>Позиции</span>
                                <b>—</b>
                            </div>
                            <div>
                                <span>Текущая цена</span>
                                <b>—</b>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className={styles.contextTitle}>Продолжить работу</div>
                        <div className={`${styles.lastProject} ${styles.lastProjectEmpty}`}>
                            Пока ни одного проекта — начните с кнопки «Создать проект»
                        </div>
                    </>
                )}
            </div>
        </section>
    );
};